import { isUserOnMobile, isUserOnTV } from "@sinclair-digital/cabin-auth-library";
import { createContext, useContext, useState } from "react";

export interface DeviceContext {
	isMobile: boolean;
	isTV: boolean;
	setIsMobile: (isMobile: boolean) => void;
	setIsTV: (isTV: boolean) => void;
}

export const DeviceContext = createContext<DeviceContext>({
	isMobile: false,
	isTV: false,
	setIsMobile: () => {},
	setIsTV: () => {},
});

export function useDevice() {
	return useContext(DeviceContext);
}

export function DeviceProvider({ children }: { children: React.ReactNode }) {
	const [isMobile, setIsMobile] = useState<boolean>(() => isUserOnMobile());
	const [isTV, setIsTV] = useState<boolean>(() => isUserOnTV());

	return (
		<DeviceContext.Provider value={{ isMobile, isTV, setIsMobile, setIsTV }}>
			{children}
		</DeviceContext.Provider>
	);
}
